import { Suspense, useCallback } from 'react';
import { branch, compose } from 'recompose';
import { ErrorBoundary } from '~/components/Tools';
import { useLocation } from 'react-router-dom';
import { LoadRemote } from '@mindtickle/ui-shell-core/DynamicRemote';
import { DELAYS } from '@mindtickle/ui-shell-core/tti';

//@ts-ignore
import { reload } from '@mindtickle/utils';

import { withRedux } from '~/components/Redux';
import { withTranslationsInternal } from '~/components/Intl';
import { useFreshchatHelpers } from '~/components/Freshchat';
import { withMixpanel } from '~/components/Mixpanel';
import { useDatadogHelpers } from '~/components/Datadog';

import { APPLICATIONS, getApplicationAccessLink } from '~/components/ApplicationUrls';

import { DEFAULT_ERROR_FALLBACK as ErrorFallback, DYNAMIC_REMOTES } from '~/config/app.constants';
import ENV from '~/config/env';

// TODO: remove once we have GA for reorg
import { getActiveTab } from './helpers';

//@ts-ignore
import useLogout from 'ui_auth/useLogout';

import AdminHeaderLoader from './Loader';

function AdminHeader() {
  const logout = useLogout();
  const { clearFreshchatUser } = useFreshchatHelpers();
  const { clearUser: clearDatadogUser } = useDatadogHelpers();

  const logoutWithCleanup = useCallback(async () => {
    await logout();
    reload(getApplicationAccessLink(APPLICATIONS.LOGIN));
    clearFreshchatUser();
    clearDatadogUser();
  }, [clearDatadogUser, clearFreshchatUser, logout]);

  const location = useLocation();

  const activeTab = getActiveTab(location.pathname);

  return (
    <ErrorBoundary
      fallback={({ error }) => (
        <ErrorFallback error={error} message="Error occurred while loading admin header" />
      )}
    >
      <Suspense fallback={<AdminHeaderLoader />}>
        <LoadRemote
          remote={DYNAMIC_REMOTES.ADMIN_HEADER}
          loader={<AdminHeaderLoader />}
          lazy={true}
          maxDelay={DELAYS.S}
          search={true}
          activeTab={activeTab}
          logout={logoutWithCleanup}
        />
      </Suspense>
    </ErrorBoundary>
  );
}

export default compose(
  withTranslationsInternal({
    appName: DYNAMIC_REMOTES.ADMIN_HEADER.appName,
    loader: <AdminHeaderLoader />,
  }),
  withRedux(),
  branch(() => !!ENV.TRACKING, withMixpanel())
)(AdminHeader);
